import React, { useState, useEffect } from "react";

import { fontMedium } from '../../utils/AppStyle';
import { isNullOrEmpty, toFirstCapital } from "../../utils/AppUtil";
import { initiateAAConsent } from "../../utils/NetworkUtil";

import { withRouter } from "react-router";
import { useHistory } from "react-router-dom";
import { aaBackPressedErrorCode } from "../../utils/Strings";
import { Loader } from "../../utils/Loader";
import { getLoaderStyle, saafeProdName, saafeUatName } from "../../Config";

const AAProcessing = ({ setShowCancel }) => {
    let history = useHistory();
    const [aaMobile, setAAMobile] = useState(sessionStorage.getItem('aa_mobile'));
    const [vua, setVua] = useState(sessionStorage.getItem('aa_vua'));
    const [multiAA, setMultiAA] = useState(localStorage.getItem('multi_aa'));

    useEffect(() => {
        if (sessionStorage.getItem('proper_redirection') == "true") {
            setShowCancel("false");
            handleNext();
        }
        else {
            sessionStorage.setItem('status_code', aaBackPressedErrorCode);
            sessionStorage.setItem('status', false);
            history.push("/txncomplete");
        }
    }, []);

    const handleNext = () => {
        var txnId = sessionStorage.getItem("txn_id");
        initiateAAConsent(aaMobile, aaMobile + "@" + vua, txnId, history, handleNextCb);
    }

    const handleNextCb = (response) => {
        //window.location.href = response.data.data.redirection_url;
        let vuaName = vua;
        let responseVua = response?.data?.data?.vua;
        if (!isNullOrEmpty(responseVua)) {
            vuaName = responseVua.split("@")[1];
            setVua(vuaName);
            sessionStorage.setItem('aa_vua', vuaName);
        }
        sessionStorage.setItem("proper_redirection", "false");
        let vendorName = (vuaName == saafeUatName) ? saafeProdName : vuaName;
        let url = response?.data?.data?.redirection_url + "&vendor_name=" + vendorName;
        if (!isNullOrEmpty(response?.data?.data?.iframe_loading) && (response?.data?.data?.iframe_loading == 1)) {
            history.push("/aacallback", { aaUrl: url, iframeLoading: true, terminalEvents: response?.data?.data?.terminal_events });
        }
        else {
            window.location.href = url;
        }
    }

    return (
        <div>


            <div className="normal-card">
                <Loader loaderStyle={getLoaderStyle()} />
                <br /><br />
                {
                    (!isNullOrEmpty(vua)) ? <div className="card-msg" style={fontMedium}>We are checking your registration status with {((!isNullOrEmpty(multiAA)) && (multiAA == "1")) ? "" : toFirstCapital(vua)} Account Aggregator (RBI Licensed). Please do not close or go back.</div> : null
                }
                <br />
                {/* <div className="card-msg" style={fontMedium}>
                        {processingDesc}
                    </div> */}
            </div>

        </div>
    );
};

export default withRouter(AAProcessing);
